import { render, staticRenderFns } from "./ClientVisitPlans.vue?vue&type=template&id=3537880f"
import script from "./ClientVisitPlans.vue?vue&type=script&lang=js"
export * from "./ClientVisitPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports